import Question from '@/components/InspectionReport/Items/Question';

export default {
    functional: true,
    props: {
        items: {
            type: Array,
            required: true,
        },
        resource: {
            type: Object,
            required: true,
        },
    },
    render(h, { props, parent }) {
        if (!props.items.length) {
            return null;
        }

        const title = `${parent.$t('Negative answers')} (${
            props.items.length
        })`;

        return h('div', [
            h(
                'h2',
                { class: 'border-b-4 border-black py-2 mt-8 text-2xl font-black' },
                title,
            ),
            props.items.map((item) => h(Question, {
                props: {
                    item,
                    resource: props.resource,
                    withIssues: false,
                },
            })),
        ]);
    },
};
